import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { useTheme } from 'react-jss';
import useStyles from './styles';
import clsx from 'clsx';
import { Icon } from '../Icon';

var Accordion = function Accordion(_ref) {
  var _clsx3;

  var children = _ref.children,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      title = _ref.title,
      inlineStyles = _ref.inlineStyles;
  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });

  var _useState = useState(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var headerStyle = clsx(_defineProperty({}, classes.header, true));
  var titleStyle = clsx(_defineProperty({}, classes.title, true));
  var contentStyle = clsx((_clsx3 = {}, _defineProperty(_clsx3, classes.content, true), _defineProperty(_clsx3, classes.active, open), _clsx3));
  return React.createElement("div", {
    style: inlineStyles
  }, React.createElement("div", {
    className: headerStyle,
    onClick: function onClick() {
      return setOpen(function (oldState) {
        return !oldState;
      });
    }
  }, React.createElement("div", {
    className: titleStyle
  }, title), React.createElement(Icon, {
    name: open ? 'ExpandLess' : 'ExpandMore',
    width: 35,
    height: 35,
    inlineStyles: {
      width: 'auto'
    }
  })), React.createElement("div", {
    className: contentStyle
  }, children));
};

export { Accordion };